// src/components/home/BinCleaning.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Trash2, Check } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { binCleaningFeatures, binCleaningPrices } from '../../data/binCleaning';
import { BUSINESS_INFO } from '../../utils/constants';
import WhatsAppIcon from '../ui/WhatsAppIcon';

const BinCleaning = () => {
  // Show only the headline prices on the home page
  const highlightPrices = binCleaningPrices.filter((p) =>
    ['one-bin', 'subscription', 'commercial'].includes(p.id)
  );

  return (
    <section className="section section-black">
      <div className="container">
        <div className="section-header">
          <div className="eyebrow">New Service</div>
          <h2>Professional Bin Cleaning</h2>
          <p>
            Keep your bins clean, fresh and hygienic with ARA's professional bin
            cleaning service. We deep clean, sanitise and deodorise your bins at
            the kerbside.
          </p>
        </div>

        {/* Highlight prices */}
        <div className="grid grid-3" style={{ marginBottom: '3rem' }}>
          {highlightPrices.map((price) => (
            <Card key={price.id} hover className={`pricing-card ${price.popular ? 'popular' : ''}`}>
              {price.badge && (
                <div className="pricing-card-badge">{price.badge}</div>
              )}
              <div className="pricing-card-header">
                <h3 className="pricing-card-name">{price.name}</h3>
                <div className="pricing-card-price">{price.price}</div>
                <div className="pricing-card-vehicle">{price.unit}</div>
              </div>
              <p style={{ color: 'var(--text-secondary)', fontSize: '0.875rem', marginBottom: '0.5rem', textAlign: 'center' }}>
                {price.sizes}
              </p>
            </Card>
          ))}
        </div>

        {/* Key features preview */}
        <div className="grid grid-4" style={{ marginBottom: '3rem' }}>
          {binCleaningFeatures.slice(0, 4).map((feature, idx) => {
            const Icon = feature.icon;
            return (
              <Card key={idx} hover className="value-card">
                <div className="value-icon">
                  <Icon size={28} />
                </div>
                <h3 style={{ fontSize: '1.0625rem', marginBottom: '0.5rem', color: 'var(--white)' }}>
                  {feature.title}
                </h3>
                <p className="value-description">{feature.description}</p>
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/pricing#bin-cleaning">
            <Button variant="primary" size="lg" icon={Trash2}>
              View Bin Cleaning Prices
            </Button>
          </Link>
          <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
            <Button variant="whatsapp" size="lg" icon={WhatsAppIcon}>
              Book a Bin Clean
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BinCleaning;